import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {useContactDataQuery} from 'presentation/queries/useContactDataQuery';
import {useGetB2BBeneficiaryStatusQuery} from 'presentation/queries/useGetB2BBeneficiaryStatusQuery';

export function usePersonalData() {
	const accountData = useAccountDataStore(state => state.accountData);
	const {data: isB2BBeneficiary} = useGetB2BBeneficiaryStatusQuery({
		userCode: accountData.beneficiary.cdUsuarioC,
	});
	const {data: contactData} = useContactDataQuery();
	const isB2BBeneficiaryAuthorized = isB2BBeneficiary ?? false;
	const userName = accountData.beneficiary.nmSocialUsuarioC || accountData.beneficiary.nmUsuarioC;

	const userLocation = contactData?.endereco;

	const emptyLocation =
		!userLocation?.nmUf ||
		!userLocation?.nmCidade ||
		!userLocation?.nmBairro ||
		!userLocation?.nmTipoLogradouro ||
		!userLocation?.nmRua ||
		!userLocation?.nuCep;

	return {
		accountData,
		currentEmail: contactData?.email,
		currentPhone: contactData?.telefone,
		userName,
		userLocation,
		emptyLocation,
		isB2BBeneficiaryAuthorized,
	};
}
